module.exports = __webpack_public_path__ + "static/img/expand-icon.1a2138ac.png";